'use client'

import { useEffect, useRef } from 'react'
import { useRouter } from 'next/navigation'
import { useAuth } from '@/contexts/auth-context'
import { useAppMode } from '@/contexts/app-mode-context'

/**
 * Client component that handles authentication-based redirects
 * This is separated from the landing page to allow the main page to be a Server Component
 * 
 * Optimized: No longer blocks the page with a loading screen.
 * The page renders immediately and redirects happen in the background.
 */
export function LandingRedirect() {
  const router = useRouter()
  const { isAuthenticated, isLoading: authLoading } = useAuth()
  const { mode } = useAppMode()
  const hasRedirected = useRef(false)

  useEffect(() => {
    // Only redirect if we're authenticated and haven't redirected yet
    // Don't wait for authLoading to be false - let the page render immediately
    if (!authLoading && isAuthenticated && !hasRedirected.current) {
      hasRedirected.current = true
      // Small delay to ensure page is rendered before redirect
      const timer = setTimeout(() => {
        if (mode === 'child') {
          router.push('/child')
        } else {
          router.push('/dashboard')
        }
      }, 100)
      return () => clearTimeout(timer)
    }
  }, [authLoading, isAuthenticated, mode, router])

  // Don't block the page - return null so content renders immediately
  return null
}


